import { missingRhythmGeometry } from "./missingRhythmGeometry";

// Coordinates are in the destination SVG layer, including any OSMD scaling.
// Anchor to staff lines, never to the note/rest bounding box or stem.
export function rhythmCountPosition(vf, element, layer) {
  const geometry = missingRhythmGeometry(vf, element, layer);
  if (!geometry) return null;
  return {
    x: geometry.x,
    y: geometry.bottomY + 1.8 * geometry.spacing,
  };
}
